<template>
  <div>
    <div class="tw-flex tw-justify-between tw-items-center tw-gap-2 tw-mb-8">
      <h1>{{ $t('adm.internal.faq.title') }}</h1>
      <router-link to="/administration/internal/faq/new">
        <i-button
          type="primary"
          size="medium"
        >
          <icon-plus class="tw-mr-2" />
          {{ $t('adm.internal.faq.create_button') }}
        </i-button>
      </router-link>
    </div>

    <div v-loading="isLoading">
      <div
        class="tw-overflow-auto"
      >
        <AdministrationTableList
          store-path="v2/admin/cms/internal/faq"
          list-relative-path="faqs"
          list-item-component-name="InternalFaqListItem"
          list-item-prop-name="faq"
          :columns="columns"
        />
      </div>
      <AdministrationTablePagination
        store-path="v2/admin/cms/internal/faq"
        filter-relative-path="filters"
      />
    </div>
    <ForeignersMessagingPopover />
  </div>
</template>

<script>
import ForeignersMessagingPopover from '@/components/Foreigners/Messaging/ForeignersMessagingPopover.vue';
import AdministrationTablePagination from '@/components/Administration/components/AdministrationTablePagination.vue';
import AdministrationTableList from '@/components/Administration/components/AdministrationTableList.vue';
import { faqTableColumns } from '@/components/Administration/Internal/Faq/constants';
import { mapState } from 'vuex';

export default {
  name: 'InternalFaqV2',
  components: {
    AdministrationTablePagination,
    AdministrationTableList,
    ForeignersMessagingPopover,
  },
  data() {
    return {
      isAddPlaceDialogOpen: false,
    };
  },
  computed: {
    ...mapState({
      filters: (state) => state.v2.admin.cms.internal.faq.filters,
      isLoading: (state) => state.v2.admin.cms.internal.faq.isLoading,
    }),
    columns() {
      return faqTableColumns;
    },
  },
  watch: {
    filters: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$store.dispatch('v2/admin/cms/internal/faq/load');
    },
  },
};
</script>
